/**
 * DC «Лавка» — заявки клиентов из «Юни Лавки». Клиент купил привилегию за
 * юникоины → заявка падает сюда (pending). Менеджер «Выполнено» (применил
 * скидку при брони / выслал видео) или «Отклонить» (коины вернутся клиенту).
 *
 * Источник правды — /api/shop-orders (perm clients). Корень/состояния — общий
 * dcSections.module.css; карточки — инлайн-токены (--role зелёный у DC).
 */
import { useState, type CSSProperties } from "react";
import { useShopOrders } from "../../hooks/useShopOrders";
import css from "./dcSections.module.css";

function fmtBiz(s: string): string {
  const d = new Date(s.replace(" ", "T") + "Z");
  if (isNaN(d.getTime())) return s;
  const b = new Date(d.getTime() + 5 * 3600 * 1000); // UTC+5 (Оренбург)
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(b.getUTCDate())}.${p(b.getUTCMonth() + 1)} ${p(b.getUTCHours())}:${p(b.getUTCMinutes())}`;
}

const card: CSSProperties = { border: "1px solid var(--surface-3)", borderLeft: "3px solid var(--role)", borderRadius: 9, padding: "11px 12px", margin: "0 0 9px", background: "var(--surface-1)" };
const topRow: CSSProperties = { display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 8 };
const nameS: CSSProperties = { fontSize: 14, fontWeight: 700, color: "var(--text-1)" };
const costS: CSSProperties = { fontSize: 13, fontWeight: 700, color: "var(--role)", whiteSpace: "nowrap" };
const titleS: CSSProperties = { margin: "4px 0 0", fontSize: 13, color: "var(--text-1)" };
const metaS: CSSProperties = { margin: "3px 0 0", fontSize: 11, color: "var(--text-3)" };
const actions: CSSProperties = { display: "flex", gap: 8, marginTop: 10 };
const btnBase: CSSProperties = { flex: 1, padding: "8px 10px", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer", border: "1px solid var(--surface-3)" };
const btnDone: CSSProperties = { ...btnBase, background: "var(--role)", color: "#06121a", borderColor: "var(--role)" };
const btnCancel: CSSProperties = { ...btnBase, background: "transparent", color: "var(--text-2)" };

export function DcShopOrdersSection({ onToast }: { onToast: (m: string) => void }) {
  const { orders, loading, error, reload, resolve } = useShopOrders("pending");
  const [busy, setBusy] = useState<number | null>(null);

  const act = async (id: number, status: "done" | "cancelled") => {
    if (busy != null) return;
    setBusy(id);
    const r = await resolve(id, status);
    setBusy(null);
    onToast(r.ok
      ? status === "done" ? "Заявка выполнена" : "Заявка отклонена — коины возвращены"
      : `Ошибка: ${r.error ?? "—"}`);
  };

  if (error) {
    return (
      <div className={css.main}>
        <div className={css.err}>Ошибка загрузки: {error}</div>
        <div style={{ marginTop: 10 }}>
          <button type="button" style={btnCancel} onClick={reload}>Повторить</button>
        </div>
      </div>
    );
  }
  if (loading) return <div className={css.main}><div className={css.loading}>Загрузка…</div></div>;
  if (orders.length === 0) return <div className={css.main}><div className={css.empty}>Заявок Лавки нет</div></div>;

  return (
    <div className={css.main}>
      <div className={css.counter}>В работе: <b>{orders.length}</b></div>
      {orders.map((o) => (
        <div key={o.id} style={card}>
          <div style={topRow}>
            <span style={nameS}>{o.client_name || "Игрок"}</span>
            <span style={costS}>−{o.cost_uc} 🪙</span>
          </div>
          <div style={titleS}>{o.title}</div>
          <div style={metaS}>#{o.id} · {fmtBiz(o.created_at)}{o.client_id ? ` · клиент ${o.client_id}` : ""}</div>
          <div style={actions}>
            <button type="button" style={btnDone} disabled={busy === o.id} onClick={() => act(o.id, "done")}>
              {busy === o.id ? "…" : "Выполнено"}
            </button>
            <button type="button" style={btnCancel} disabled={busy === o.id} onClick={() => act(o.id, "cancelled")}>
              Отклонить
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
